<template>
  <!-- -->
  <div class="p-grid p-fluid" style="padding-bottom: 2%; width: 100%">
    <Panel header="Pesquisar declarantes" class="p-col-12" style="">
      <div class="p-grid p-fluid" style="padding-bottom: 2%">
        <Rotulo nome="Digite CPF, matrícula ou nome" cols="12">
          <AutoComplete
            v-model="textoBusca"
            :suggestions="resultadoBusca"
            @complete="searchPessoaExercicio($event)"
            @item-select="selecionarPessoaExercicio($event)"
            field="nomePessoa"
          >
            <template #item="slotProps">
              <div>
                <b>CPF/Matricula:</b> {{ slotProps.item.cpfFormatado }}/{{
                  slotProps.item.numrMatricula
                }}
                - <b>Nome: </b>{{ slotProps.item.nomePessoa }}
              </div>
            </template>
          </AutoComplete>
        </Rotulo>
      </div>
      <!--<div class="p-grid p-fluid" style="padding-bottom: 2%"  >
        <DataTable :value="dadosBusca" :selection.sync="dadosBuscaSelecionado">
          <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
          <Column field="pessoa.nomePessoa" header="Nome"></Column>
          <Column field="pessoa.cpfFormatado" header="CPF"></Column>
          <Column v-if="pessoa.servidor!=null" field="pessoa.servidor.numrMatricula" header="Matrícula"></Column>
          <Column v-else field="pessoa.cpfFormatado" header="Matrícula"></Column>
          <Column field="parametroExercicio.exercicio.ano" header="Exercício"></Column>
        </DataTable>
      </div>-->
    </Panel>
    <Panel header="Selecionar Exercícios" class="p-col-12">
      <PickList v-model="pessoaExercicios" dataKey="idenPessoaExercicio">
        <template #sourceHeader> Disponíveis </template>
        <template #targetHeader> Selecionados </template>
        <template #item="slotProps">
          <div class="p-caritem">
            <div>
              {{ slotProps.item.anoExercicio }} -
              {{ slotProps.item.nomePessoa }}
            </div>
          </div>
        </template>
      </PickList>

      <Rotulo nome="" cols="12"> </Rotulo>
      <Rotulo nome="Período de acesso" cols="4">
        <div class="p-grid p-fluid">
          <Rotulo cols="6">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"> Início </span>
              <InputMask
                v-model="registro.dataInicioPermissao"
                mask="99/99/9999"
                placeholder="99/99/9999"
              />
            </div>
          </Rotulo>
          <Rotulo cols="6">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"> Fim </span>
              <InputMask
                v-model="registro.dataFimPermissao"
                mask="99/99/9999"
                placeholder="99/99/9999"
              />
            </div>
          </Rotulo>
        </div>
      </Rotulo>
    </Panel>
    <Panel header="Documento comprobatório" class="p-col-12">
      <Rotulo nome="Descrição" cols="12">
        <Textarea v-model="registro.descMotivo" rows="5" cols="30" />
      </Rotulo>
      <Rotulo
        nome="Anexar arquivo contendo autorização legal para acesso às declarações do(s) declarante(s) informado(s)"
        cols="12"
        class="rotulo"
        requerido
      >
        <div class="cardButtonFile">
          <FileUpload
            name="file[]"
            accept="application/pdf"
            :maxFileSize="3028000"
            chooseLabel="Selecionar arquivo"
            uploadLabel="Enviar"
            cancelLabel="Cancelar"
            :fileLimit="1"
            :previewWidth="60"
            invalidFileSizeMessage="{0}: Tamanho de arquivo inválido, o tamanho do arquivo deve ser menor que 3MB."
            invalidFileLimitMessage="Número máximo de arquivo excedido, o limite é {0} no máximo"
            @uploader="onUpload"
            :customUpload="true"
            v-if="listaArquivo.length == 0"
          >
            <template #empty>
              <div class="display-flex-center">
                <i class="pi pi-download icon-arraste"></i>
                <p class="texto-arraste">Escolha o arquivo ou arraste aqui</p>
              </div>
            </template>
          </FileUpload>

          <DataTable
            :value="listaArquivo"
            class="p-datatable-responsive-demo p-datatable-gridlines"
            v-if="listaArquivo.length > 0"
          >
            <Column
              field="tipoExtensaoArquivo"
              header="Extensão"
              headerStyle="width: 8rem"
              bodyClass="columnAlign"
            >
              <template #body="slotProps">
                <span class="p-column-title">Extensão:</span>
                {{ slotProps.data.tipoExtensaoArquivo }}
              </template>
            </Column>

            <Column
              field="descArquivo"
              header="Arquivo"
              bodyClass="columnAlign"
            >
              <template #body="slotProps">
                <span class="p-column-title">Arquivo:</span>
                <span>{{ slotProps.data.descArquivo }}</span>
              </template>
            </Column>

            <Column
              headerStyle="width: 8em"
              bodyClass="columnAlign"
              header="Ação"
            >
              <template #body="slotProps">
                <Button
                  type="button"
                  icon="pi pi-replay"
                  @click="changeArquivo(slotProps.data)"
                  class="p-button-raised p-button-warning"
                  style="margin-right: 0.5rem"
                />

                <Button
                  type="button"
                  icon="pi pi-print"
                  @click="download(slotProps.data.idenArquivo)"
                  class="p-button-raised"
                />
              </template>
            </Column>
          </DataTable>

          <Dialog
            :header="tituloAlterarArquivo"
            :visible.sync="isShowDialogAlterarArquivo"
            class="dialogo-termo-aceite"
            :modal="true"
          >
            <FileUpload
              name="file[]"
              accept="application/pdf"
              :maxFileSize="2028000"
              chooseLabel="Selecionar arquivo"
              uploadLabel="Enviar"
              cancelLabel="Cancelar"
              :fileLimit="1"
              :previewWidth="60"
              invalidFileSizeMessage="{0}: Tamanho de arquivo inválido, o tamanho do arquivo deve ser menor que 1MB."
              invalidFileLimitMessage="Numero maximo de arquivo excedido, o limite é {0} no máximo"
              @uploader="onUploadChangeArquivo"
              :customUpload="true"
            >
              <template #empty>
                <div class="display-flex-center">
                  <i class="pi pi-download icon-arraste"></i>
                  <p class="texto-arraste">Escolha o arquivo ou arraste aqui</p>
                </div>
              </template>
            </FileUpload>
          </Dialog>
        </div>
      </Rotulo>
    </Panel>

    <CardExibirPDF
      :tamanhoTela="'85,vw'"
      :alturaTela="'120,vh'"
      :pdfElement="dadosArquivoBase64"
      v-model="isExibirPDF"
      :tituloTela="tituloPDF"
      v-if="isExibirPDF"
    />

    <div style="width: 100%; border: 1px solid white">
      <div class="p-col-12 p-md-4" style="float: right">
        <Button
          label="Salvar"
          class="p-button-success"
          icon="pi pi-check"
          style="margin-top: 1rem"
          @click="salvarPermissao()"
          :disabled="false"
        />
      </div>
    </div>
    <Panel
      header="Permissões atribuídas ao Fiscalizador"
      class="p-col-12"
      v-if="permissoesAtribuidas.content.length > 0"
    >
      <DataTable
        :value="permissoesAtribuidas.content"
        dataKey="idenPermissaoFiscal"
        responsiveLayout="scroll"
        class="p-col-12"
      >
        <Column field="nomePessoa" header="Nome" sortable></Column>
        <Column field="descOrgao" header="Órgão" sortable></Column>
        <Column field="cpfFormatado" header="CPF" sortable></Column>
        <Column field="anoExercicio" header="Exercicio" sortable></Column>
        <Column
          field="dataInicioPermissao"
          header="Data Início"
          sortable
        ></Column>
        <Column field="dataFimPermissao" header="Data Fim" sortable></Column>
        <Column header="Autorização Legal">
          <template #body="slotProps">
            <Button
              label="Arquivo"
              type="button"
              icon="pi pi-print"
              @click="download(slotProps.data.idenArquivo)"
              class="p-button-raised"
              v-tooltip.top="'Imprimir'"
            />
          </template>
        </Column>
      </DataTable>
    </Panel>
  </div>
</template>
<script>
import { baseApiUrl } from "@/config/global";
import { printToast } from "@/config/global";
import Rotulo from "@/template/RotuloSeplag.vue";
import CardExibirPDF from "@/template/CardExibirPDF";
export default {
  name: "usuario-fiscal",
  components: { Rotulo, CardExibirPDF },
  data: function () {
    return {
      textoBusca: null,
      resultadoBusca: null,
      registro: {
        dataInicioPermissao: null,
        dataFimPermissao: null,
        descMotivo: null,
      },
      idenPessoaSelecionada: null,
      idenPessoaExercicio: null,
      dadosBusca: [{ pessoa: null }],
      dadosBuscaSelecionado: [],
      tituloPDF: " ",
      listaArquivo: [],
      changeArquivoObj: null,
      tituloAlterarArquivo: "",
      isShowDialogAlterarArquivo: false,
      dadosArquivoBase64: "",
      isExibirPDF: false,
      changeFileLabel: "",
      pessoaExercicios: [[], []],
      permissoesAtribuidas: {
        content: [],
      },
    };
  },
  props: {
    data: {
      type: Object,
      require: true,
    },
    perfis: {
      type: Array,
      require: true,
    },
  },
  methods: {
    async carregarDados() {
      this.registro = {
        dataInicioPermissao: null,
        dataFimPermissao: null,
        descMotivo: null,
      };
      this.listaArquivo = [];
      this.pessoaExercicios = [[], []];
      this.textoBusca = null;
      this.buscarPermissoesAtribuidas();
    },
    buscarPermissoesAtribuidas() {
      this.$http
        .post(
          `${baseApiUrl}/permissoesfiscais/buscarTodasPermissoesPorFiscalizador/${this.data.pessoa.idenPessoa}`
        )
        .then((res) => {
          this.permissoesAtribuidas = res.data;
        });
    },

    searchPessoaExercicio() {
      this.idenPessoaSelecionada = null;
      //let qtdCaracteres = this.isNumber(this.textoBusca) ? 2 : 5
      let qtdCaracteres = 2;
      if (this.textoBusca.length >= qtdCaracteres) {
        this.$http
          .post(
            `${baseApiUrl}/pessoaexercicios/buscarDeclarantesPorNomeOuCpfOuMatricula/`,
            this.textoBusca
          )
          .then((res) => {
            this.resultadoBusca = res.data;
          });
      }
    },
    selecionarPessoaExercicio(evento) {
      this.idenPessoaSelecionada = evento.value.idenPessoa;
      this.$http
        .get(
          `${baseApiUrl}/pessoaexercicios/buscarTodosPorPessoa/${this.idenPessoaSelecionada}`
        )
        .then((res) => {
          //this.pessoaExercicios = [ res.data, [] ]
          this.pessoaExercicios = [res.data, this.pessoaExercicios[1]];
        });
    },
    searchAudit() {
      this.$http
        .get(
          `${baseApiUrl}/auditorias/pessoaexercicio/${this.idenPessoaExercicio}?size=50&page=0`
        )
        .then((res) => {
          this.dados = res.data;
          //this.reorganizarDados()
        });
    },
    onUpload(data) {
      let formData = new FormData();
      formData.append("file", data.files[0]);

      this.$http
        .post(
          `${baseApiUrl}/permissoesfiscais/upload/autorizacao/${this.data.pessoa.idenPessoa}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          data.files.splice(0, data.files.length);
          this.listaArquivo.push(res.data);
        });
    },
    changeArquivo(data) {
      this.changeArquivoObj = { ...data };
      //this.isAlterarIR = true;
      this.tituloAlterarArquivo = `Alterar arquivo ${data.descArquivo}`;
      this.isShowDialogAlterarArquivo = true;
    },
    onUploadChangeArquivo(data) {
      let formData = new FormData();
      formData.append("file", data.files[0]);

      this.$http
        .post(
          `${baseApiUrl}/permissoesfiscais/upload/autorizacao/${this.data.pessoa.idenPessoa}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          this.listaArquivo = [];
          data.files.splice(0, data.files.length);
          this.listaArquivo.push(res.data);
          this.tituloAlterarArquivo = ``;
          this.isShowDialogAlterarArquivo = false;
        });
    },
    download(idenArquivo) {
      this.$http
        .get(`${baseApiUrl}/arquivodeclaracaobens/download/base64/${idenArquivo}`)
        .then((res) => {
          this.dadosArquivoBase64 = res.data;
          this.isExibirPDF = true;
        });
    },
    salvarPermissao() {
      let registro = {
        pessoaFiscal: this.data.pessoa,
        pessoasExercicio: this.pessoaExercicios[1],
        descMotivo: this.registro.descMotivo,
        dataInicioPermissao: this.registro.dataInicioPermissao,
        dataFimPermissao: this.registro.dataFimPermissao,
        arquivo: this.listaArquivo[0],
      };
      this.$http
        .post(`${baseApiUrl}/permissoesfiscais`, JSON.stringify(registro))
        .then(() => {
          this.carregarDados();
          printToast({
            severity: "success",
            summary: "Sucesso",
            detail: "Permissão salva com sucesso",
          });
        });
    },
  },

  mounted() {
    this.carregarDados();
  },
};
</script>
<style>
.p-picklist-target-controls,
.p-picklist-source-controls {
  display: none;
}
.display-flex-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>